module.exports = __webpack_public_path__ + "static/media/8.e3964b7c.jpg";